/**
 * @generated SignedSource<<7ef6411a6f7324cd791bfc7fa8d89f72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventAttendContent_query$data = {
  readonly viewer: {
    readonly id: string;
    readonly slugId: string;
  } | null | undefined;
  readonly " $fragmentType": "EventAttendContent_query";
};
export type EventAttendContent_query$key = {
  readonly " $data"?: EventAttendContent_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendContent_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendContent_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slugId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6b8bba92c630eedda2725ffbf6d08799";

export default node;
